'use strict';

export const Constants = Object.freeze({
  CONFIRM_MODAL: {
    TEXT: 'Launching a new Traffic Channel of this type will close the existing Traffic Channel.',
    ONLY_ONE_TRAFFIC_CHANNEL_LIVE:
      'You may have only 1 Traffic Channel live at a time for this type.',
    CONFIRM_BUTTON_TEXT: 'Continue',
  },
});
